import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, IconButton, CircularProgress, TextField,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fAlertToast, fcheck_null_undefine_replace_empty } from '../../../Utility/Utilitys';
import { SalesInvoice_getTransPdf, SalesInvoice_TransISDocUpdate } from '../../../Server/ApiV2';
import GCWebReport from './GCWebReport';

const FileUploadModal = ({ open, fCloseSearchModal, A_VocTyp, A_VocNo }) => {
  let initState = "";
  const [preview, setpreview] = useState(false);
  const [images, setImages] = useState("");
  const [filePath, setfilePath] = useState("");
  const GetRow = async () => {
    let obj = {
      TransID: A_VocTyp + "," + A_VocNo,
    };

    let resp = await SalesInvoice_getTransPdf(
      fcheck_null_undefine_replace_empty(obj)
    );
    console.log("resp", resp);
    if (resp?.status === 200) {
      if (resp?.data?.length > 0) {
        console.log(resp.data);

        setImages(resp.data);
        setfilePath("File");
      } else {
        setImages(initState);
        setfilePath("");
      }
    } else {
      if (resp.response.status == 500) {
        fAlertToast(
          "FAILED",
          resp.response.data.message.msg ||
            "error in ValidateInvTransHeadUpdate "
        );
      }
    }
  };

  useEffect(() => {
    if (open) {
      GetRow();
    }
  }, [open]);

  const handleImageChange = (e, index) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setfilePath(e.target.value);
      setImages(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const handleUpload = async () => {
    try {
     
        let resp = await SalesInvoice_TransISDocUpdate({
          TransID: A_VocTyp + "," + A_VocNo,
          Pdf: images,
        });
        console.log("resp", resp);
        if (resp?.status === 200) {
          fAlertToast("SUCCESS", "Images uploaded successfully.");
        } else {
          if (resp.response?.status === 500) {
            fAlertToast(
              "FAILED",
              resp.response.data.message.msg ||
                "Error in ValidateInvTransHeadUpdate"
            );
          }
        }
      
    } catch (error) {
      console.error("Error during upload:", error);
      fAlertToast("FAILED", "Failed to upload images.");
    }
  };

  const handleDeleteImage = (index) => {
    setImages("");
    setfilePath("");
  };
  return (
    <Dialog open={open}  onClose={()=>{
      setImages(initState);
      setfilePath("");
      fCloseSearchModal()}} maxWidth="sm" fullWidth  
     
      >
      <DialogTitle  sx={{ bgcolor: 'primary.main', color: '#fff',  }}>
        Attachment
        <IconButton
          aria-label="close"
          onClose={() => {
            setImages(initState); 
            setfilePath("");
            fCloseSearchModal(); 
          }}
          onClick={fCloseSearchModal} 
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
          <TextField
                  size="small"
                  fullWidth
                  variant="outlined"
                  value={filePath}
                  InputProps={{ readOnly: true }}
                />
          </Grid>
          <Grid item xs={12}>
            <Button
              variant="contained"
              component="label"
              fullWidth
              color="primary"
            >
              Choose File
              <input
                type="file"
                hidden
                onChange={(e) => handleImageChange(e)}
              />
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={handleUpload}
             
            >
              Upload
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                if (  images == "") {
                  fAlertToast("FAILED", "Choose one pdf file");
                  return;
                } else {
                  setpreview(true);
                }
              }}
              sx={{
                padding: "10px 20px",
                "@media (max-width: 600px)": {
                  width: "100%",
                },
              }} 
            >
              Preview
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="outlined"
              color="primary"
              fullWidth
              onClick={() => {
                if (images== "") {
                  fAlertToast("FAILED", "No file uploaded");
                  return;
                } else {
                  handleDeleteImage();
                }
               
              }}
            >
              Reset
            </Button>
          </Grid>
          <Box>
            <GCWebReport
              xfCloseWebReportModal={() => {
                setpreview(false);
              }}
              xWebReportUrlModal={images}
              xTitle="PDF"
              xWebReportModal={preview}
            />
          </Box>
        </Grid>
      </DialogContent>
      
    </Dialog>
  );
};

export default FileUploadModal;
